module.exports = __webpack_public_path__ + "static/media/icons-ic-incoming-call-connected.379ab3b8.svg";